function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "text_bubble",
  "data-name": "text bubble"
}, /*#__PURE__*/React.createElement("path", {
  d: "M530,74.07C506.4,39.73,472.09,13.13,411.15,5.64,229.44-11.43,76.35,22,37.2,50.58-4.13,80.74-5.91,129.24,11.15,162.92c40.67,54.66,139.56,59.36,315.58,59.23,55.91.77,96.83-2.83,126.87-8.53,20.27,44.92-39.77,118.81-60.18,140.86-13.05,13.32-18.27,26-17.71,25.31C409,345.13,453.89,307.36,482,243.1c10.79-26.54,19.56-41.65,23.06-45.16l1.46-.72h0c25.12-12.47,29.8-25.83,32-30.22C545.46,152.93,553.53,108.41,530,74.07Z",
  fill: "#fffdf5",
  stroke: "#2d2d2d",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

function SvgBubble1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546.67 380.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CC7\u7522 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble1);
export default __webpack_public_path__ + "static/media/bubble1.6808e4a6.svg";
export { ForwardRef as ReactComponent };